import Rule from '@/common/components/rule';
import { cn } from '@/shadcn-ui/utils';

interface SavingsRulesProps {
  color: 'bg-flexcar-neutral90' | 'bg-flexcar-neutral100';
}

export default function SavingsRules({ color }: SavingsRulesProps) {
  return <Rule className={cn('h-[2px', color)} direction="horizontal" />;
}
